import {
  Box,
  Dialog,
  FormControlLabel,
  IconButton,
  Radio,
  styled,
  Typography,
} from "@mui/material";
import moment from "moment";
import React, { useEffect, useState } from "react";
import Close from "../assets/svg/Close";
import Upload from "../assets/svg/Upload";
import { apiPost } from "../utils/Api/ApiCalls";
import { API_ROUTES } from "../utils/Api/ApiConfig";
import { colors } from "../utils/colors/Index";
import CustomButton from "./common/CustomButton";
import BasicDatePicker from "./common/Datepicker";
import TextFieldBox from "./common/TextField";
function CreateFeed({
  open,
  setOpen,
  data,
  feedsName = "feeds",
  setRender = () => null,
}) {
  const [formData, setFormData] = useState({
    file: null,
    title: "",
    streamedDate: null,
    videoLink: "",
    description: "",
  });
  const [errors, setErrors] = useState({});
  const [fileName, setFileName] = useState("");
  const [selectedFeedType, setSelectedFeedType] = useState(feedsName);
  const [loader, setLoader] = useState(false);

  useEffect(() => {
    if (data?._id) {
      setFormData({
        file: data?.feedImageUrl,
        title: data?.title,
        streamedDate: data?.streamedOn,
        videoLink: data?.videoLink,
        description: data?.description,
      });
      setSelectedFeedType(feedsName);
    }
  }, [data?._id]);

  // const handleFileChange = (e) => {
  //   const file = e.target.files[0];
  //   setFileName(file ? file.name : "");
  //   setFormData({ ...formData, file });
  // };
  const handleFileChange = async (event) => {
    const file = event.currentTarget.files[0];
    if (file) {
      const allowedTypes = ["image/jpeg", "image/png", "image/jpg"];
      if (allowedTypes.includes(file.type) && file.type.startsWith("image/")) {
        const base64 = await convertFileToBase64(file);
        setFileName(file ? file.name : "");
        setFormData({ ...formData, file: base64 });
      } else {
        alert("Only JPEG, JPG, and PNG images are allowed.");
      }
    }
  };
  const convertFileToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        resolve(reader.result);
      };
      reader.onerror = () => {
        reject(new Error("Failed to convert file to Base64"));
      };
      reader.readAsDataURL(file);
    });
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleDateChange = (date) => {
    console.log(date);
    setFormData({ ...formData, streamedDate: moment(new Date(date)).format() });
  };
  const validateForm = () => {
    const newErrors = {};
    if (!formData.title) newErrors.title = "Title is required";
    if (!formData.streamedDate)
      newErrors.streamedDate = "Streamed Date is required";
    if (!formData.videoLink) newErrors.videoLink = "Video link is required";
    if (!formData.description)
      newErrors.description = "Description is required";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  const handleClose = () => {
    setOpen(false);
    setFormData({
      file: null,
      title: "",
      streamedDate: null,
      videoLink: "",
      description: "",
    });
    setFileName("");
  };
  const handleSubmit = async () => {
    if (!validateForm()) return;
    setLoader(true);
    const bodyData = {
      image: formData.file?.split(",")[1],
      id: data?._id || null,
      action: selectedFeedType || null,
      title: formData.title,
      streamedOn: formData.streamedDate,
      videoLink: formData.videoLink,
      description: formData.description,
    };
    try {
      const response = await apiPost(API_ROUTES.POST_FEEDS, bodyData);
      if (response.status === 201) {
        console.log("Form submitted successfully:", response.data);
        handleClose();
        setRender((prev) => !prev);
      }
    } catch (error) {
      console.log("Error submitting form:", error);
    } finally {
      setLoader(false);
    }
  };
  const feedsType = [
    { name: "Feeds", value: "feeds" },
    { name: "Banner (Home Page)", value: "banners" },
  ];

  const handleChangeFeed = (event) => {
    const { value } = event.target;
    setSelectedFeedType(value);
  };
  const handleRemoveBtn = () => {
    setFormData({ ...formData, file: null });
    setFileName("");
  };

  return (
    <Dialog
      open={open}
      maxWidth="md"
      fullWidth
      PaperProps={{ elevation: 3, sx: { borderRadius: "1rem" } }}
    >
      <Box
        sx={{
          display: "flex",
          width: "100%",
          flexDirection: "column",
          padding: "1rem",
          rowGap: "1rem",
          position: "relative",
        }}
      >
        <IconButton
          onClick={handleClose}
          sx={{
            position: "absolute",
            top: "0",
            right: "0",
            padding: "0.5rem",
          }}
        >
          <Close />
        </IconButton>
        <Typography
          variant="h5"
          color={colors.text.primary}
          sx={{ mb: "1rem" }}
        >
          Create Feed
        </Typography>

        {!data?._id && (
          <RadioContainer>
            {feedsType.map((value, i) => (
              <FormControlLabel
                key={i}
                checked={value?.value === selectedFeedType}
                onChange={handleChangeFeed}
                value={value?.value}
                control={
                  <Radio
                    sx={{
                      color: "gray", // Default color
                      "&.Mui-checked": {
                        color: "#EF6C00", // Checked color
                      },
                    }}
                  />
                }
                label={value?.name}
              />
            ))}
          </RadioContainer>
        )}

        <LabelTypography>Upload Image</LabelTypography>
        {!formData?.file && (
          <FileUploadBox>
            <Upload />
            <Typography
              sx={{
                color: colors.text.primary,
                marginLeft: "0.5rem",
                fontSize: "14px",
              }}
            >
              {fileName || "Drop File here or Click to upload"}
            </Typography>
            <HiddenFileInput
              type="file"
              accept="image/jpeg, image/png, image/jpg"
              onChange={handleFileChange}
            />
          </FileUploadBox>
        )}

        {formData?.file && (
          <ImageContainer>
            <RemoveBtn onClick={handleRemoveBtn}>
              <Close color="white" />
            </RemoveBtn>
            <Image src={formData?.file} />
          </ImageContainer>
        )}

        <LabelTypography>Title Name</LabelTypography>
        <TextFieldBox
          placeholder=""
          name="title"
          value={formData.title}
          onChange={handleChange}
          error={!!errors.title}
          helperText={errors.title}
        />
        <LabelTypography>Streamed Date</LabelTypography>
        <BasicDatePicker
          value={formData.streamedDate}
          onChange={handleDateChange}
          error={!!errors.streamedDate}
          helperText={errors.streamedDate}
        />
        <LabelTypography>Video Link</LabelTypography>
        <TextFieldBox
          placeholder=""
          name="videoLink"
          value={formData.videoLink}
          onChange={handleChange}
          error={!!errors.videoLink}
          helperText={errors.videoLink}
          type="url"
        />
        <LabelTypography>Description</LabelTypography>
        <TextFieldBox
          multiline={true}
          rows={3.5}
          placeholder=""
          name="description"
          value={formData.description}
          onChange={handleChange}
          error={!!errors.description}
          helperText={errors.description}
        />
        <Box display={"flex"} columnGap={"1rem"} width={"50%"}>
          <CustomButton
            title="Post"
            variant="contained"
            fullWidth
            handleClick={handleSubmit}
            loading={loader}
            sx={{
              backgroundColor: "#E8503A",
              color: "white",
              textTransform: "capitalize",
              borderRadius: "8px",
            }}
          />
          <CustomButton
            title="Close"
            variant="outlined"
            fullWidth
            handleClick={handleClose}
            sx={{
              borderColor: "#ACACAC",
              color: "#606067",
              textTransform: "capitalize",
              borderRadius: "8px",
            }}
          />
        </Box>
      </Box>
    </Dialog>
  );
}

export default CreateFeed;

const FileUploadBox = styled(Box)(({ theme }) => ({
  border: "2px dashed #76A2FF",
  borderRadius: 8,
  backgroundColor: "#EFFAFF",
  padding: "0.5rem",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  cursor: "pointer",
  position: "relative",
  transition: "border-color 0.3s",
  "&:hover": {
    borderColor: "2px dashed #76A2FF",
  },
}));

const HiddenFileInput = styled("input")({
  position: "absolute",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  opacity: 0,
  cursor: "pointer",
});

const LabelTypography = styled(Typography)(({ theme }) => ({
  color: colors.text.primary,
  fontSize: "14px",
}));

const RadioContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  flexWrap: "wrap",
  gap: 5,
}));

const RemoveBtn = styled(Box)(({ theme }) => ({
  position: "absolute",
  backgroundColor: "#E8503A",
  right: 0,
  top: 0,
  borderRadius: 0,
  width: 24,
  height: 24,
}));

const ImageContainer = styled(Box)(({ theme }) => ({
  width: "10%",
  height: "10%",
  position: "relative",
}));
const Image = styled("img")(({ theme }) => ({
  width: "100%",
  height: "100%",
}));
